import { IonRouterOutlet } from '@ionic/angular/standalone';

import { IONIC_IMPORTS } from '@shared/imports.ts/ionic.imports';

const MODULES = [...IONIC_IMPORTS, IonRouterOutlet];
const COMPONENTS = [];
const PIPES = [];
export const APP_IMPORTS = [...MODULES, ...COMPONENTS, ...PIPES];
